"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SdkError_1 = require("./SdkError");

exports.ERR_SDK_NOT_INITIALIZED = SdkError_1.SdkError.fromAny('sdk not initialized');
exports.ERR_SDK_ALREADY_INITIALIZED = SdkError_1.SdkError.fromAny('sdk already initialized');
exports.ERR_ACCOUNT_DISCONNECTED = SdkError_1.SdkError.fromAny('account disconnected');
exports.ERR_ACCOUNT_ALREADY_CONNECTED = SdkError_1.SdkError.fromAny('account already connected');
exports.ERR_INVALID_ACCOUNT_STATE = SdkError_1.SdkError.fromAny('invalid account state');
exports.ERR_INVALID_ACCOUNT_DEVICE_STATE = SdkError_1.SdkError.fromAny('invalid account device state');
exports.ERR_INVALID_ACCOUNT_DEVICE_TYPE = SdkError_1.SdkError.fromAny('invalid account device type');
exports.ERR_WRONG_NUMBER_OF_ARGUMENTS = SdkError_1.SdkError.fromAny('wrong number of arguments');
exports.ERR_INVALID_GAME_CREATOR = SdkError_1.SdkError.fromAny('invalid game creator');
exports.ERR_INVALID_GAME_STATE = SdkError_1.SdkError.fromAny('invalid game state');
exports.ERR_EXTENSION_ALREADY_ADDED = SdkError_1.SdkError.fromAny('extension already added');
exports.ERR_EXTENSION_NOT_ADDED = SdkError_1.SdkError.fromAny('extension not added');
exports.ERR_ADDING_EXTENSION_IN_PROGRESS = SdkError_1.SdkError.fromAny('adding extension in progress');
exports.ERR_NOT_ENOUGH_REAL_FUNDS = SdkError_1.SdkError.fromAny('not enough real funds');
exports.ERR_NOT_ENOUGH_VIRTUAL_FUNDS = SdkError_1.SdkError.fromAny('not enough virtual funds');